import { Text, View } from '@react-pdf/renderer';
import { checkObjHasValues } from 'utils';
import parse from 'html-react-parser';

const Awards = ({ styles, data = [], headerTitle }: any) => {
	return (
		<View style={styles.mainBox}>
			<View style={styles.headingBox}>
				<Text style={styles.heading}>{headerTitle}</Text>
			</View>

			<View style={styles.mainBoxInner}>
				{data?.map((res: any, idx: number) => {
					if (checkObjHasValues(res)) {
						return (
							<View key={`${res?.title}-${res?.year}`} style={styles.detailBox}>
								<View style={styles.detailBoxContent}>
									<Text style={styles.detailText}>{res?.title}</Text>
									<Text style={styles.detailSubText}>{res?.year}</Text>
									{res?.description && (
										<Text style={styles.detailSubText}>{parse(res.description)}</Text>
									)}
								</View>
							</View>
						);
					}
				})}

				{/* <View style={styles.detailBox}>
					<View style={styles.detailBoxContent}>
						<Text style={styles.detailText}>Web Designing Award</Text>
						<Text style={styles.detailSubText}>2020</Text>
						<Text style={styles.detailSubText}>
							Lorem ipsum dolor sit amet, conse ctetur adipiscing elit, sed do eiusmod
						</Text>
					</View>
				</View> */}
			</View>
		</View>
	);
};

export default Awards;
